import { Button, CircularProgress } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useMutation } from "react-query";
import {
  geAttendanceCertificate,
  geDisChargeSummary,
  getGeneralConsent,
  getMedicalConsent,
  getProcedureForm,
} from "../services";
import { useParams } from "react-router-dom";
import { useState } from "react";
import SickLeaveForm from "../SickLeaveForm";
import FitForCertificateForm from "../FitForCertificateForm";
import CaseInjuryCertificate from "../CaseInjuryCertificate";
import ReferralLetterForm from "../ReferralLetterForm";
import AttentandLeaveForm from "../AttentandLeaveForm";
import usePopup from "../../../../hooks/usePopup";
import PatientConsentForm from "../PatientConsentForm";
import usePrint from "../../../../hooks/usePrint";
import useAuthentication from "@hooks/useAuthentication";


function ConsentFormV1() {
  const { encounterId: id } = useParams();
  const {printPdf,loading} = usePrint()
  const encounterId = parseInt(id as string);
  const [selected, setSelected] = useState<number>(-1);
  const { CustomModal,showSnackbar } = usePopup();
  const [showConsent, setShowConsent] = useState(false);
  const {user} = useAuthentication()
  const { mutate: downloadProcedureForm, isLoading: procedureFormLoading } =
    useMutation(getProcedureForm, {
      onSuccess: (result) => {
        if(result.responseIndicator == "success" && result.response){
          printPdf(result.response)
        }else{
          showSnackbar({
            message:result.responseMessage,
            open:true,
            variant:"warning",
            duration:2000
          })
        }
      },
    });
  const { mutate: downloadeMedicalConsent, isLoading: medicalConsentLoading } =
    useMutation(getMedicalConsent, {
      onSuccess: (result) => {
        if(result.responseIndicator == "success" && result.response){
          printPdf(result.response)
        }else{
          showSnackbar({
            message:result.responseMessage,
            open:true,
            variant:"warning",
            duration:2000
          })
        }
      },
    });

  const { mutate: downloadeGeneralConsent, isLoading: generalConsentLoading } =
    useMutation(getGeneralConsent, {
      onSuccess: (result) => {
        if(result.responseIndicator == "success" && result.response){
          printPdf(result.response)
        }else{
          showSnackbar({
            message:result.responseMessage,
            open:true,
            variant:"warning",
            duration:2000
          })
        }
      },
    });

  const { mutate: downloadeAttendance, isLoading: attendanceLoading } =
    useMutation(geAttendanceCertificate, {
      onSuccess: (result) => {
        if(result.responseIndicator == "success" && result.response){
          printPdf(result.response)
        }else{
          showSnackbar({
            message:result.responseMessage,
            open:true,
            variant:"warning",
            duration:2000
          })
        }
      },
    });
  const { mutate: downloadeDisCharge, isLoading: disChargeLoading } =
    useMutation(geDisChargeSummary, {
      onSuccess: (result) => {
        if(result.responseIndicator == "success" && result.response){
          printPdf(result.response)
        }else{
          showSnackbar({
            message:result.responseMessage,
            open:true,
            variant:"warning",
            duration:2000
          })
         }
      },
    });
  const handleDownload = (index: number) => {
    setSelected(index);
    switch (index) {
      case 0:
        downloadProcedureForm(encounterId);
        break;
      case 1:
        downloadeMedicalConsent(encounterId);
        break;
      case 2:
        downloadeGeneralConsent(encounterId);
        break;
      case 3:
        console.log(index);
        break;
      case 4:
        console.log(index);
        break;
      case 5:
        console.log(index);
        break;
      case 6:
        console.log(index);
        break;
      case 7:
        console.log(index);
        break;
      case 8:
        downloadeAttendance(encounterId);
        break;
      case 9:
        downloadeDisCharge({id:encounterId,tenetClinicId:Number(user?.tenantClinicId)});
        break;
      case 10:
        setShowConsent(true);
        break;
    }
  };

  console.log("user===>",user)

  return (
    <div className="w-[50vw] h-[50dvh]">
      <CustomModal
        title="Consent form"
        open={showConsent}
        setOpen={setShowConsent}
      >
        <div className="w-[79vw] max-h-[90dvh] overflow-y-auto p-2">
          <PatientConsentForm />
        </div>

      </CustomModal>
      <div className="grid grid-cols-5 gap-3 p-3">
        {consentForms.map((formText, index: number) => {
          return (
            <div
              key={`formButtons${index}`}
              className="flex gap-2"
            >
              <Button
                fullWidth
                variant={selected == index ? "contained" : "outlined"}
                endIcon={
                  (procedureFormLoading ||
                    medicalConsentLoading ||
                    generalConsentLoading ||
                    disChargeLoading ||
                    attendanceLoading  || loading) &&
                    index == selected ? (
                    <CircularProgress size={20} />
                  ) : (
                    <PictureAsPdfIcon />
                  )
                }
                disabled={
                  (procedureFormLoading ||
                    medicalConsentLoading ||
                    generalConsentLoading ||
                    disChargeLoading ||
                    attendanceLoading || loading) &&
                  index == selected
                }
                onClick={() => {
                  handleDownload(index);
                }}
              >
                {formText}
              </Button>
            </div>
          );
        })}
      </div>

      {selected == 3 && (
        <div className="m-3">
          <SickLeaveForm />
        </div>
      )}
      {selected == 4 && (
        <div className="m-3">
          <FitForCertificateForm />
        </div>
      )}
      {selected == 5 && (
        <div className="m-3">
          <CaseInjuryCertificate />
        </div>
      )}
      {selected == 6 && (
        <div className="m-3">
          <ReferralLetterForm />
        </div>
      )}
      {selected == 7 && (
        <div className="m-3">
          <AttentandLeaveForm />
        </div>
      )}
    </div>
  );
}

export default ConsentFormV1;
const consentForms = [
  "Procedure form",
  "Medical consent form",
  "General consent form",
  "Sick leave certificate",
  "Fit for certificate",
  "Case injury certificate",
  "Referral letter certificate",
  "Attendant leave ",
  "Attendance certificate",
  "Discharge summary",
  "Patient consent",
];
